<div class="main-home">
    <header>
        <mat-toolbar color="primary">
            <span>WonderBudget</span>
            <span>&nbsp;{{ authDomain }}</span>
            <span class="example-fill-remaining-space"></span>
            <button [matMenuTriggerFor]="menu" mat-button>
                <mat-icon>person</mat-icon>&nbsp;@if ((userStream$ | async); as user) {
                <span>
          {{ user.email }}
        </span>
            }
            </button>
            <mat-menu #menu="matMenu">

                @if ((userStream$ | async); as user) {
                    <div>
                        @if ((!user)) {
                            <button (click)="loginWithGoogle()" mat-menu-item type="button">
                                <mat-icon>flight_depa</mat-icon>
                                <span>Login</span>
                            </button>
                        } @else {
                            <button (click)="logoutWithFireBase()" mat-menu-item type="button">
                                <mat-icon>flight_land</mat-icon>
                                <span>Logout</span>
                            </button>
                        }
                    </div>
                }
            </mat-menu>
        </mat-toolbar>
    </header>
    <main id="main">

        <mat-card class="home-login">
            <mat-card-content>
                <img alt="logo" class="logo-extravega" id="logo-home" src="/assets/img/extravega-logo.svg">
                <div class="home-control-container">
                    @if (!(authCheckEmitter$ | async)) {
                        <div>
                            <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
                        </div>
                    }
                    @if ((authCheckEmitter$ | async)) {
                        <div>
                            @if (!(userStream$ | async); as user) {
                                <div (click)="loginWithGoogle()"
                                     class="login-with-google">
                                    <img alt="" src="/assets/img/btn_google_signin_light_normal_web@2x.png">
                                </div>
                            }
                            @if ((userStream$ | async); as user) {
                                <div>
                                    @if (canSeeBudgets$ | async) {
                                        <div>
                                            <button [routerLink]="['/budget']" i18n mat-raised-button type="button">
                                                Enter
                                            </button>
                                        </div>
                                    }
                                    @if (!(canSeeBudgets$ | async)) {
                                        <div>
                                            <button [routerLink]="['/timereport']" i18n mat-raised-button type="button">
                                                Enter
                                            </button>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    }
                    @if (isLoginError) {
                        <p class="loginError" i18n>Error while trying to login. Please try again</p>
                    }
                </div>
            </mat-card-content>
        </mat-card>
    </main>
    <app-footer></app-footer>
</div>
